// Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="header">
      <div className="header-left">
        <Link to="/">
          <img src="/images/Fintexel Logo-07.png" alt="Fintexl Logo" className="logo" />
        </Link>
        <div className="brand-info">
          <div className="brand-subtitle">AYAANSH FINANCIAL</div>
          <div className="brand-subtitle">SOLUTIONS PRIVATE LIMITED</div>
        </div>
      </div>

      <div className={`nav-toggle ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>☰</div>

      <nav className={`nav-links ${isMenuOpen ? 'mobile-visible' : ''}`}>
        <Link to="/" onClick={toggleMenu}>Home</Link>
        <Link to="/about" onClick={toggleMenu}>About</Link>
        <div className="dropdown">
          <Link to="/services" className="dropdown-toggle" onClick={toggleMenu}>Services</Link>
          <div className="dropdown-menu">
            <Link to="/services/virtual-cfo" onClick={toggleMenu}>Virtual CFO Services</Link>
            <Link to="/services/bookkeeping" onClick={toggleMenu}>Bookkeeping & Accounting</Link>
            <Link to="/services/taxation" onClick={toggleMenu}>Taxation Services</Link>
            <Link to="/services/corporate-law" onClick={toggleMenu}>Corporate Law & Secretarial</Link>
            <Link to="/services/startup-consulting" onClick={toggleMenu}>Startup Consulting</Link>
            <Link to="/services/business-advisory" onClick={toggleMenu}>Business Advisory</Link>
            <Link to="/services/international-business" onClick={toggleMenu}>International Business</Link>
            <Link to="/services/payroll-hr" onClick={toggleMenu}>Payroll & HR Services</Link>
          </div>
        </div>
        <div className="dropdown">
          <Link to="/industries" className="dropdown-toggle" onClick={toggleMenu}>Industries</Link>
          <div className="dropdown-menu">
            <Link to="/industries/it-software" onClick={toggleMenu}>IT & Software</Link>
            <Link to="/industries/manufacturing-engineering" onClick={toggleMenu}>Manufacturing & Engineering</Link>
            <Link to="/industries/real-estate" onClick={toggleMenu}>Real Estate & Infrastructure</Link>
            <Link to="/industries/media-entertainment" onClick={toggleMenu}>Media & Entertainment</Link>
            <Link to="/industries/retail-ecommerce" onClick={toggleMenu}>Retail & E-commerce</Link>
            <Link to="/industries/bfsi" onClick={toggleMenu}>Banking, Financial Services, and Insurance</Link>
            <Link to="/industries/tourism-hospitality" onClick={toggleMenu}>Hospitality & Tourism </Link>
            <Link to="/industries/agro-aqua" onClick={toggleMenu}>Aquaculture & Agriculture</Link>
            <Link to="/industries/healthcare" onClick={toggleMenu}>Health Care</Link>
            <Link to="/industries/education" onClick={toggleMenu}>Education</Link>
            <Link to="/industries/ngos-trusts" onClick={toggleMenu}>NGOs and Trusts</Link>
          </div>
        </div>
        <Link to="/blog" onClick={toggleMenu}>Blogs</Link>
        <Link to="/contact" onClick={toggleMenu}>Contact</Link>
      </nav>
    </header>
  );
}

export default Header;












